import { LevelEntity } from 'shared/domain/level/types/entity';
import { debugLog } from 'shared/logger/debugLog';
import { IssueEntity } from '../issue/entity';

export const createDocumentationIssuesMap = (
  issues: IssueEntity[],
  levels: LevelEntity[]
): Map<string, number> => {
  const docIssuesMap = new Map<string, number>();

  issues.forEach((issue) => {
    const levelId = issue.primaryData.level;
    const level = levels.find((l) => l._id === levelId);

    if (!level) {
      debugLog(
        'createDocumentationIssuesMap: Level not found for levelId:',
        levelId
      );
      return;
    }

    const documentationId = level.map?.documentationId;
    if (!documentationId) {
      return;
    }
    docIssuesMap.set(documentationId, (docIssuesMap.get(documentationId) || 0) + 1);
  });

  return docIssuesMap;
};
